// extracted by mini-css-extract-plugin
module.exports = {"layout":"TwoColumnsBlock_layout__rfP1a"};